import { Directive, HostListener, Input, ElementRef  } from '@angular/core';

@Directive({
  selector: '[appCollapse]'
})
export class CollapseDirective {
    @Input() containerID = "";
    collapseElement: ElementRef;

    constructor(el: ElementRef) {
        this.collapseElement = el;
    }

    @HostListener('click', ['$event'])
    clickEvent(event) {
        //event.preventDefault();
        //event.stopPropagation();

        if (this.collapseElement.nativeElement.style.transform == "rotate(180deg)")
            this.collapseElement.nativeElement.style.transform = "";
        else
            this.collapseElement.nativeElement.style.transform = "rotate(180deg)";
    }
}
